"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stack = void 0;
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

var stack = exports.stack = [];